import React from 'react'
import clsx from 'clsx'
import { makeStyles, createStyles } from '@material-ui/core'
import PackPrice from '../Shop/PackPrice'
import {
  PRICE_WITHOUT_DISCOUNT,
  DISCOUNTED_PRICE_ONLY,
  DISCOUNTED_PRICE_WITH_DETAILS,
  isClassicSub,
} from '../../utils/constants'

export const useStyles = makeStyles((theme) =>
  createStyles({
    oldPrice: {
      textDecoration: 'line-through',
    },
    marginLeft: {
      marginLeft: theme.spacing(1),
    },
    promotion: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
      borderRadius: theme.spacing(0.5),
      fontSize: '75%',
      marginLeft: theme.spacing(1),
      padding: theme.spacing(0, 0.5),
    },
  })
)

type TProps = {
  promotions: any
  settings: any
  minPrice: number
  discountPriceFormat: string
  isDisplayPercentage?: boolean
}

const PackPriceFormat = ({
  promotions,
  settings,
  minPrice: productPrice,
  discountPriceFormat,
  isDisplayPercentage = false,
}: TProps) => {
  const classes = useStyles()
  const currentPromotion = promotions?.currentPromotion
  const isPerMonth = settings?.show_price_per_month

  const minPrice = productPrice * (isPerMonth ? 30 : 1)
  return (
    <>
      {!isClassicSub && !currentPromotion && (
        <PackPrice data={settings} amount={minPrice} />
      )}
      {!isClassicSub &&
        currentPromotion !== null &&
        currentPromotion &&
        discountPriceFormat === PRICE_WITHOUT_DISCOUNT && (
          <PackPrice data={settings} amount={minPrice} />
        )}
      {!isClassicSub &&
        currentPromotion !== null &&
        currentPromotion &&
        discountPriceFormat === DISCOUNTED_PRICE_ONLY && (
          <PackPrice
            data={settings}
            amount={minPrice - (minPrice * currentPromotion) / 100}
          />
        )}
      {!isClassicSub &&
        currentPromotion !== null &&
        currentPromotion &&
        discountPriceFormat === DISCOUNTED_PRICE_WITH_DETAILS && (
          <div className="pack__amount">
            <span className={clsx('pack__oldPrice', classes.oldPrice)}>
              <PackPrice
                data={settings}
                amount={minPrice}
                showDayOrMonth={false}
              />
            </span>
            <span className={classes.marginLeft}>
              <PackPrice
                data={settings}
                amount={minPrice - (minPrice * currentPromotion) / 100}
              />
            </span>
            {isDisplayPercentage && (
              <span className={clsx('pack__discount', classes.promotion)}>
                -{currentPromotion}&nbsp;%
              </span>
            )}
          </div>
        )}
    </>
  )
}

export default PackPriceFormat
